import React, {useState} from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { SectionHeading, Subheading as SubheadingBase } from "components/misc/Headings.js";
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";
import EmailIllustrationSrc from "images/email-illustration.png";
import translate from "../../lang/translate";

const Container = tw.div`relative`;
const TwoColumn = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto py-20 md:py-24`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const ImageColumn = tw(Column)`md:w-5/12 flex-shrink-0 h-80 md:h-auto`;
const TextColumn = styled(Column)(props => [
  tw`md:w-7/12 mt-16 md:mt-0`,
  props.textOnLeft ? tw`md:mr-12 lg:mr-16 md:order-first` : tw`md:ml-12 lg:ml-16 md:order-last`
]);

const Image = styled.div(props => [
  `background-image: url("${props.imageSrc}");`,
  tw`rounded bg-contain bg-no-repeat bg-center h-full`,
]);
const TextContent = tw.div`lg:py-8 text-center md:text-left`;

const Subheading = tw(SubheadingBase)`text-center md:text-left`;
const Heading = tw(SectionHeading)`mt-4 font-black text-left text-3xl sm:text-4xl lg:text-5xl text-center md:text-left leading-tight`;
const Description = tw.p`mt-4 text-center md:text-left text-sm md:text-base lg:text-lg font-medium leading-relaxed text-secondary-100`

const Form = tw.div`mt-8 md:mt-10 text-sm flex flex-col max-w-sm mx-auto md:mx-0`
const Input = tw.input`mt-6 first:mt-0 border-b-2 py-3 focus:outline-none font-medium transition duration-300 hocus:border-primary-500`
const Textarea = styled(Input).attrs({as: "textarea"})`
  ${tw`h-24`}
`

const SubmitButton = tw.button(PrimaryButtonBase)`inline-block mt-8`

export default ({
  subheading = translate('home_page.contact_us.title'),
  heading = <>{translate('home_page.contact_us.desc1')} <span tw="text-primary-500">{translate('home_page.contact_us.desc2')} </span><wbr/> {translate('home_page.contact_us.desc3')} </>,
  description = "",
  submitButtonText = translate('home_page.contact_us.form.send'),
  formAction = "",
  formMethod = "",
  textOnLeft = true,
}) => {
  const [email,setEmail] = useState("");
  const [name,setName] = useState("");
  const [subject,setSubject] = useState("");
  const [message,setMessage] = useState("");



  const HandleSubmit = async () => {
    if(email!=="" && name!=="" && subject!=="" && message!==""){
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email, name: name, subject: subject, message: message})
      };
      const response = await fetch('https://dynaskills-mail.herokuapp.com/', requestOptions);
      const data = await response.json();
      setEmail("");
      setName("");
      setSubject("");
      setMessage("");
      console.log(data.data);
      alert(data.data);
    }
  };

  return (
    <Container id="contact_section">
      <TwoColumn>
        <ImageColumn>
          <Image imageSrc={EmailIllustrationSrc} />
        </ImageColumn>
        <TextColumn textOnLeft={textOnLeft}>
          <TextContent>
            {subheading && <Subheading>{subheading}</Subheading>}
            <Heading>{heading}</Heading>
            {description && <Description>{description}</Description>}
            <Form >
              <Input  type="email" name="email" value={email} placeholder="Your Email Address" onChange={(e)=>setEmail(e.target.value)} />
              <Input type="text" name="name" value={name} placeholder="Full Name" onChange={(e)=>setName(e.target.value)} />
              <Input type="text" name="subject" value={subject} placeholder="Subject" onChange={(e)=>setSubject(e.target.value)} />
              <Textarea name="message" value={message} placeholder="Your Message Here" onChange={(e)=>setMessage(e.target.value)} />
              <SubmitButton onClick={HandleSubmit}  >{submitButtonText}</SubmitButton>
            </Form>
          </TextContent>
        </TextColumn>
      </TwoColumn>
    </Container>
  );
};
